import { ServiceCard } from '@/components/orders/ServiceCard'
import { Article, Order, SharedProps } from '@/types'
import { Head, router } from '@inertiajs/react'
import { Card, Group, Stack, Text } from '@mantine/core'

interface ArticleShowProps extends SharedProps {
  order: Order
  article: Article
}

export default function ArticleShow({ order, article, current_organization }: ArticleShowProps) {
  if (!current_organization) throw new Error('Organization is required for ArticleShow')

  const { article_name, services } = article

  return (
    <>
      <Head title={`Article : ${article_name} - Commande #${order.id}`} />

      <Stack mb="lg" gap="xs">
        <Group gap={4}>
          <Text
            size="sm"
            c="brand"
            style={{ cursor: 'pointer' }}
            onClick={() => router.visit(`/organizations/${current_organization.slug}/orders/${order.id}`)}
          >
            Commande #{order.id}
          </Text>
          <Text size="sm" c="dimmed">
            &gt;
          </Text>
          <Text size="sm" c="dimmed">
            {article_name}
          </Text>
        </Group>
      </Stack>

      <Card withBorder radius="md" padding="xl" shadow="sm">
        <Stack gap="lg">
          <Text fw={700} tt="uppercase" mb={4}>
            Commande #{order.id}
          </Text>

          <div>
            <Text size="xs" fw={700} tt="uppercase" c="dimmed" mb={4}>
              Article
            </Text>
            <Text fw={900} size="h2" style={{ textTransform: 'uppercase' }}>
              {article_name}
            </Text>
          </div>

          <div>
            <Stack>
              {services.map((service) => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </Stack>
          </div>
        </Stack>
      </Card>
    </>
  )
}
